<template>
  <div class="wrapper">
    <parallax class="section "></parallax>
    <div class="main ">
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <b-breadcrumb id="inNav" style="background:transparent;">
                <b-breadcrumb-item
                  style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  href="/"
                  >Home</b-breadcrumb-item
                >
                <b-breadcrumb-item
                  style="color: #c1a360 !important; //styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  active
                  >Contact us</b-breadcrumb-item
                >
              </b-breadcrumb>
              <h2 class="title">Be one of our customers</h2>
              <h4 class=" description">
                To become one of our special customers fill the form below, and
                one of our consultants will contact you within the next few
                hours.
              </h4>
              <h3 class="Details">
                Personal Details
              </h3>
              <form name="myForm" class="contact-form">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Full Name</label>
                      <md-input
                        name="fname"
                        v-model="name"
                        type="text"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Email Address</label>
                      <md-input
                        name="email"
                        v-model="email"
                        type="email"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Phone Number</label>
                      <md-input
                        name="number"
                        v-model="PhoneNumber"
                        type="text"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
                <h3 class="Details">
                  Message Details
                  <span style="color:black;font-size:12px;">(Optional)</span>
                </h3>
                <div class="md-layout-item">
                  <md-field maxlength="5">
                    <label>Message Title</label>
                    <md-input v-model="messageTitle"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field maxlength="5">
                    <label>Message</label>
                    <md-textarea v-model="message"></md-textarea>
                  </md-field>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item ">
                    <md-button
                      @click="requestCall()"
                      style="background-color:#C1A360 !important; alignt:left; margin-top:20px"
                      class="md-success"
                      >Request a consultation call
                    </md-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal hide-footer="true" ref="my-modal" id="thankyou" title="Thank you">
      <img
        src="../assets/img/yourplace/sent.png"
        class="card-img-top card-height"
        style="width:100px;heigh:100px;    margin-left: 190px;"
        alt="..."
      />
      <h1 style="text-align:center;">Your request sent successfully.</h1>
      <p class="my-4" style="text-size:100px !important;">
        Thank you for choosing us, One of our consultants will contact you
        regarding your request.
      </p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { BModal } from "bootstrap-vue";
export default {
  name: "Contactus",
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg7.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      messageTitle: null,
      PhoneNumber: null
    };
  },
  methods: {
    requestCall() {
      var name = document.forms["myForm"]["fname"].value;
      var email = document.forms["myForm"]["email"].value;
      var number = document.forms["myForm"]["number"].value;
      if (name == "" || email == "" || number == "") {
        alert("please fill the missing data");
      } else if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          email
        )
      ) {
        axios
          .post(
            "/send_mail.php",
            {
              name: this.name,
              email: this.email,
              body: this.message,
              subject: this.messageTitle,
              phone_number: this.PhoneNumber
            },
            {
              headers: {
                "content-type": "application/json",
                accept: "application/json"
              }
            }
          )
          .then(response => {
            this.$bvModal.show("thankyou");
          })
          .catch(error => {
          
          });
      } else {
        alert("please enter a valid email");
      }
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.md-outline input:focus {
  border-color: #c1a360 !important;
  box-shadow: inset 0 0 0 1px #c1a360 !important;
  border-bottom: 1px solid #c1a360 !important;
}

.description {
  //styleName: Body;
  font-family: Noto Sans JP;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
}
.md-outline label.active {
  color: #c1a360 !important;
}

.Details {
  // font-family: Noto Sans JP !important;
  font-size: 21px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 32px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
  color: #c1a360 !important;
}

.title {
  //styleName: Hero;
  font-family: Noto Serif JP !important;
  font-size: 65px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 96px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
  color: black !important;
}
#inNav > li > a {
  color: black;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

@media screen and (max-width: 600px) {
  .title {
    //styleName: Hero;
    font-family: Noto Serif JP !important;
    font-size: 30px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: 96px !important;
    letter-spacing: 0em !important;
    text-align: left !important;
    color: black !important;
  }
}
</style>
